export default "__VITE_ASSET__84faa9e7__"